import { PaginatedListTable } from "./PaginatedListTable";

export default PaginatedListTable;
